import React from 'react';
import './Footer.css';
import { FaInstagram, FaTiktok, FaWhatsapp, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom'; // Yönlendirme için ekledik kanka
import tesbihLogo from '../../assets/logo22.png';

const Footer = () => {
  // Telefon ve mesaj bilgilerini tek yerden yönetelim kanka
  const phoneNumber = "905453669008";
  const tiktokLink = "https://www.tiktok.com/@tesbihcimen.collection";

  return (
    <footer className="main-footer">
      <div className="footer-container">
        
        {/* Sol: Marka ve Haber Bülteni */}
        <div className="footer-brand">
          <Link to="/">
            <img src={tesbihLogo} alt="Tesbihçimen" className="footer-logo" />
          </Link>
          <p className="footer-about">
            Geleneksel tesbih sanatını modern koleksiyonerlik anlayışıyla buluşturuyoruz. 
            Her bir hanemizde tarih ve işçilik gizli.
          </p>
          <div className="newsletter">
            <h4>Koleksiyona Katıl</h4>
            <div className="newsletter-form">
              <input type="email" placeholder="E-posta adresiniz" />
              <button>KAYDOL</button>
            </div>
          </div>
        </div>

        {/* Orta: Hızlı Menü */}
        <div className="footer-links">
          <h3>Hızlı Menü</h3>
          <ul>
            <li><Link to="/">Anasayfa</Link></li>
            <li><Link to="/kategoriler">Kategoriler</Link></li>
            <li><Link to="/urunler">Tüm Koleksiyon</Link></li>
            <li><Link to="/">Mezat Takvimi</Link></li>
          </ul>
        </div>

        {/* Sağ: İletişim */}
        <div className="footer-contact">
          <h3>İletişim</h3>
          <div className="contact-item">
            <FaWhatsapp className="c-icon" />
            <a href={`https://wa.me/${phoneNumber}`} target="_blank" rel="noreferrer">
              +90 545 366 90 08
            </a>
          </div>
          <div className="contact-item">
            <FaEnvelope className="c-icon" />
            <a href="mailto:cimenfirat02@gmail.com">cimenfirat02@gmail.com</a>
          </div>
          <div className="contact-item">
            <FaMapMarkerAlt className="c-icon" />
            <span>Türkiye / Sivas</span>
          </div>
          <div className="footer-socials">
            <a href={tiktokLink} target="_blank" rel="noreferrer"><FaTiktok /></a>
          </div>
        </div>

      </div>

      {/* En Alt: Marka İmzası ve Copyright */}
      <div className="footer-bottom">
        <div className="big-branding">TESBİHCİMEN COLLECTION</div>
        <div className="bottom-bar">
          <p>&copy; 2026 TESBİHCİMEN COLLECTION Tüm Hakları Saklıdır.</p>
          <div className="legal-links">
            <Link to="/">KVKK</Link>
            <Link to="/">Mesafeli Satış Sözleşmesi</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;